(function () {

  // ===============================
  // BUNDLE LOGIK (UÆNDRET)
  // ===============================

  async function checkVariant(id) {
    try {
      const res = await fetch(`/variants/${id}.js`);
      if (!res.ok) return { available: false };

      const data = await res.json();

      return {
        available: data.available,
        title: data.name
      };
    } catch {
      return { available: false };
    }
  }

  async function addBundle(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    return res.ok;
  }

  function parseItems(raw) {
    try {
      const parsed = JSON.parse(raw);

      return parsed.map(x => ({
        id: Number(x.id),
        quantity: Number(x.quantity || 1)
      }));

    } catch {
      return null;
    }
  }

  document.addEventListener('click', async (e) => {

    const btn = e.target.closest('[data-bundle-items]');
    if (!btn) return;

    e.preventDefault();
    btn.disabled = true;

    const original = btn.textContent;
    btn.textContent = 'Tjekker produkter…';

    const items = parseItems(btn.dataset.bundleItems);

    if (!items) {
      alert('Der er en fejl i bundle_items JSON');
      btn.disabled = false;
      btn.textContent = original;
      return;
    }

    const checks = await Promise.all(
      items.map(item => checkVariant(item.id))
    );

    let availableItems = [];
    let missing = [];

    items.forEach((item, i) => {
      if (checks[i].available) {
        availableItems.push(item);
      } else {
        missing.push(checks[i].title || item.id);
      }
    });

    if (availableItems.length === 0) {
      alert('Alle produkter i pakken er desværre udsolgt.');
      btn.disabled = false;
      btn.textContent = original;
      return;
    }

    btn.textContent = 'Tilføjer til kurv…';

    const added = await addBundle(availableItems);

    if (!added) {
      alert('Kunne ikke tilføje pakken til kurven.');
      btn.disabled = false;
      btn.textContent = original;
      return;
    }

    if (missing.length > 0) {
      alert(
        'Nogle produkter var udsolgt og blev ikke tilføjet:\n\n' +
        missing.join('\n')
      );
    }

    window.location.href = '/cart';

  });


  // ===============================
  // 🔥 MÆNGDERABAT (FIXET + MULTI-GRUPPER)
  // ===============================

  function initBulkDiscount() {

    const box = document.getElementById("bulkDiscountBox");
    if (!box) return;

    const group = box.dataset.discountGroup;

    // ❗ hvis ingen gruppe → vis ikke noget
    if (!group) {
      box.style.display = "none";
      return;
    }

    // 🔥 forskellige regler pr. produkttype
    let rules = [];

    if (group === "cykellakpensel") {
      rules = [
        { min: 24, discount: 5 },
        { min: 240, discount: 10 },
        { min: 1200, discount: 20 }
      ];
    }

    else if (group === "malerrulle-small") {
  rules = [
    { min: 10, discount: 5 },
    { min: 100, discount: 10 },
    { min: 1000, discount: 20 }
  ];
}

    else if (group === "pensel") {
  rules = [
    { min: 12, discount: 5 },
    { min: 120, discount: 10 },
    { min: 240, discount: 15 }
  ];
}

    if (rules.length === 0) {
      box.style.display = "none";
      return;
    }

    const qtyInput =
      document.querySelector('input[id^="Quantity-"]') ||
      document.querySelector('input[name="quantity"]');

    if (!qtyInput) return;

    function updateBox() {

      const qty = parseInt(qtyInput.value, 10) || 0;

      let current = null;
      let next = null;

      for (let i = 0; i < rules.length; i++) {
        if (qty >= rules[i].min) {
          current = rules[i];
        } else {
          next = rules[i];
          break;
        }
      }

let html = `
  <div class="bulk-title">Mængderabat</div>
  <div class="bulk-note">Rabatten beregnes automatisk – du ser den i kurven</div>
`;
      rules.forEach(rule => {
        html += `<div class="bulk-row">${rule.min}+ stk → <strong>${rule.discount}%</strong></div>`;
      });

      if (qty < rules[0].min) {
        const missing = rules[0].min - qty;
        html += `<div class="bulk-highlight">Køb ${missing} stk mere og få ${rules[0].discount}%</div>`;
      }

      else if (next) {
        const missing = next.min - qty;
        html += `<div class="bulk-success">Du har ${current.discount}% rabat</div>`;
        html += `<div class="bulk-next">+${missing} stk for ${next.discount}%</div>`;
      }

      else {
        html += `<div class="bulk-max">Du har højeste rabat (${current.discount}%)</div>`;
      }

      box.innerHTML = html;
    }

    qtyInput.addEventListener("input", updateBox);
    qtyInput.addEventListener("change", updateBox);

    document.addEventListener("click", function(e) {
      if (e.target.closest('.quantity__button')) {
        setTimeout(updateBox, 50);
      }
    });

    updateBox();
  }

function waitForBoxAndInit(tries = 0) {
  const box = document.getElementById("bulkDiscountBox");

  if (box) {
    initBulkDiscount();
    return;
  }

  if (tries < 30) {
    setTimeout(function() {
      waitForBoxAndInit(tries + 1);
    }, 100);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  waitForBoxAndInit();
});

document.addEventListener("shopify:section:load", function() {
  waitForBoxAndInit();
});

document.addEventListener("variant:change", function() {
  waitForBoxAndInit();
});
})();